export default __webpack_public_path__ + "static/media/DodgeFavicon.4913f10a.ico";